import { REPORTED_SUBTABS_ID } from "../../../constants/Constants";

export const mainStackStyles = {
    lineHeight: "20px",
    width: "100%",
    justifyContent: "center",
    margin: "10px 0px",
    position:"relative"
  };
  
  export const patientIdStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "11px",
    fontWeight: "400",
  };
  
  export  const patientGenderStyle = {
    fontSize: "14px",
    fontWeight: "bold",
  };
  
  export const patientAgeStyle = {
    fontSize: "14px",
    fontWeight: "400",
  };
  
  export const patientAgeChatContainer = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: "7px 0px"
  };
  export  const patientAgeContainer = {
    display: "flex",
    flex: "0.2",
  };
  export const patientChatContainer = {
    display: "flex",
    alignItems: "center",
    // flex: "1.1 1 0%",
    position: "relative",
    cursor: "pointer",
    marginLeft: "10px"
  };
  
  export const popDotStyle = {
    position: "absolute",
    left: "24px",
    top: "2px",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#F7F7F7",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  
  export  const countMessageStyle = {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "6px",
    lineHeight: "100%",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "#0078D4",
  };

 export const options = [
    { key: "patient_name", text: "Patient Name" },
    { key: "reporting_provider", text: "Radiologist" },
    { key: "patient_id", text: "Patient ID" },
    { key: "study_date", text: "Study Date" },
    { key: "modality_name", text: "Modality" },
    { key: "client_name", text: "Hospital" },
    { key: "study_description", text: "Study Description" },
    { key: "assignment_created_date", text: "Assignment Date" },
  ];

export const getCurrentActiveTabName = (tabArray, currentActiveTabId) => {
    let selectedTab = null;
    if(tabArray != undefined ){
        selectedTab = tabArray.filter((tabElement, index) => tabElement.id == currentActiveTabId);
    }
    return selectedTab[0].title;
}

export const getCurrentActiveTabId = (tabArray, currentActiveTabId) => {
  let selectedTab = null;
  if(tabArray != undefined ){
      selectedTab = tabArray.filter((tabElement, index) => tabElement.id == currentActiveTabId);
  }
  if(selectedTab[0] != undefined && selectedTab[0] != null){
    return selectedTab[0].tabNameId;
  }
  return tabArray[0].tabNameId;
 
}

export   const sortingMenuPropsItems = (sortGlobal,setSortGlobal,handleDropDownClick) => {
    let items = [
      { key: "patient_name", text: "Patient Name", iconProps: {iconName: sortGlobal.sortColumn == "patient_name"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal)},
      { key: "reporting_provider", text: "Radiologist",iconProps: {iconName: sortGlobal.sortColumn == "reporting_provider"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
      // { key: "patient_id", text: "Patient ID",iconProps: {iconName: sortGlobal.sortColumn == "patient_id"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
      { key: "study_date", text: "Study Date",iconProps: {iconName: sortGlobal.sortColumn == "study_date"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
      { key: "modality_name", text: "Modality",iconProps: {iconName: sortGlobal.sortColumn == "modality_name"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
      // { key: "client_name", text: "Hospital",iconProps: {iconName: sortGlobal.sortColumn == "client_name"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
      // { key: "study_description", text: "Study Description",iconProps: {iconName: sortGlobal.sortColumn == "study_description"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
      { key: "assignment_created_date", text: "Assignment Date",iconProps: {iconName: sortGlobal.sortColumn == "assignment_created_date"?sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown":''}, onClick:(e,data)=> handleDropDownClick(e,data,setSortGlobal,sortGlobal) },
    ];

    return items;
  }

  
export const sortOptionsFunction = (selectedValue,t) => {
  let options = [
    { key: "emergency_status", text: t("sorting.study-list.emergency-status") },
    { key: "assignment_created_date", text: t("sorting.study-list.created-on") },
    { key: "patient_name", text: t("sorting.study-list.patient-name") },
    { key: "reporting_provider", text: t("sorting.study-list.radiologist") },
    { key: "patient_id", text: t("sorting.study-list.patient-id") },
    { key: "study_date", text: t("sorting.study-list.study-date") },
    { key: "modality_name", text: t("sorting.study-list.modality") },
    { key: "client_name", text: t("sorting.study-list.hospital") },
    { key: "study_description", text: t("sorting.study-list.description") },
    
  ]
  if (REPORTED_SUBTABS_ID.includes(selectedValue)) {
    options.push( { key: "report_submitted_date", text: t("sorting.study-list.reported-date") });
  }
  return options;
 
}

  export const searchInputStyle = {
    root: {
      width: "210px",
    },
    field: {
      borderRadius: "7px",
    },
  };

  export const searchIcon = {
    iconName: "search",
    cursor: "pointer",
    style: { color: "rgba(172, 172, 172, 0.75)" },
  };

  export const checkboxStyle = {
    root: {
      margin: "7px 0",
    },
    text: {
      color: "#A19F9D",
      fontWeight: "400",
      fontSize: "14px"
    },
    checkbox: {
      borderColor: "#A19F9D",
    },
  };


 export const menuPropsItems = (tabArray,setSelectedValue) =>{
    let items = [];
   
    tabArray.map((ele,index)=>{
      let obj = null;
      if(ele.show){
        obj = {
          key: ele.title,
          // iconProps: {iconName: ''},
          text: ele.title,
          onClick:() => {setSelectedValue(ele.id);}
        }
        items.push(obj);
      }
      
    })
      return items;
   }

export const checkForNumberOfFilterApplied = (searchDto) => {
  let appliedNumber = 0;
  if(searchDto.patientNameOrId != null &&
    searchDto.patientNameOrId.length > 0){
      appliedNumber++;
    }
  if(searchDto?.modalityIds != null && searchDto?.modalityIds.length > 0){
    appliedNumber++;
  }
  if(searchDto.uploadDate != null && searchDto.uploadDate != undefined){
    appliedNumber++;
  }
  if(searchDto.clientOrFirmIds != null && searchDto.clientOrFirmIds != undefined){
    appliedNumber++;
  }
  if(searchDto.annotationId != null && searchDto.annotationId != undefined){
    appliedNumber++;
  }
  if(searchDto.aiPredictionId != null && searchDto.aiPredictionId != undefined){
    appliedNumber++;
  }
  if(searchDto.providerIds != null && searchDto.providerIds.length > 0){
    appliedNumber++;
  }
  return appliedNumber;
}
